import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useClassroomCreate = () => {
  const createClassroomPostRequest = useCallback((payload) => {
    return new Request(`${API_BASE_URL}/api/v2/classroom/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);
  return useRestMutation(createClassroomPostRequest);
};

export default useClassroomCreate;
